import { Check, MapPin } from "lucide-react";
import { Reveal, SectionHeader } from "./SectionHeader";

const CREDENTIALS = [
  "Abogada de profesión, con marcada vocación social.",
  "Graduada en Ciencias Sociales.",
  "Máster en Migraciones y Relaciones Interculturales.",
  "Diploma de Experta Profesional en «Accesibilidad Cognitiva. Lectura Fácil y Otros Recursos», por la UNED.",
];

const VALIDATORS = [
  { names: ["Maite"], role: "Dinamizadora del grupo de validación." },
  { names: ["Óscar", "Adrián", "Charlie", "Natalia", "Roberto"], role: "Validadores de lectura fácil." },
];

export default function Team() {
  return (
    <section id="equipo" className="py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <SectionHeader
          eyebrow="Quiénes somos"
          title="Personas que se entienden. Y que hacen que otras personas se entiendan."
        />
        <div className="grid lg:grid-cols-[1fr_1fr] gap-8 mt-14 items-stretch">
          <Reveal className="h-full">
            <article className="h-full sketch bg-[var(--card)] p-8 md:p-10 flex flex-col gap-6 shadow-[6px_6px_0_var(--ink)]" data-testid="team-patricia">
              <div className="flex items-center gap-5">
                <span className="inline-flex items-center justify-center w-20 h-20 shrink-0 sketch-2 bg-[var(--blue)] text-white font-display font-extrabold text-2xl">
                  PB
                </span>
                <div>
                  <p className="text-xs font-black uppercase tracking-[0.2em] text-[var(--blue-deep)]">Coordinación y adaptación</p>
                  <h3 className="font-display font-extrabold text-3xl mt-1">Patricia Bilbao</h3>
                </div>
              </div>
              <ul className="space-y-3.5">
                {CREDENTIALS.map((c) => (
                  <li key={c} className="flex items-start gap-3 text-base md:text-lg leading-relaxed">
                    <span className="mt-1 inline-flex items-center justify-center w-6 h-6 shrink-0 sketch-sm bg-[var(--yellow)]">
                      <Check className="w-3.5 h-3.5" strokeWidth={3} aria-hidden="true" />
                    </span>
                    {c}
                  </li>
                ))}
              </ul>
              <p className="mt-auto text-base leading-relaxed text-[var(--muted)] border-l-4 border-[var(--yellow)] pl-4">
                Patricia coordina el proyecto y adapta los textos. Su trabajo combina derecho, ciencias sociales y accesibilidad cognitiva.
              </p>
            </article>
          </Reveal>

          <Reveal delay={0.12} className="h-full">
            <article className="h-full sketch-2 bg-[var(--card)] flex flex-col overflow-hidden" data-testid="team-cai">
              <img
                src="https://images.unsplash.com/photo-1695938746747-ec185ea81325?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Grupo de personas conversando y apoyándose en un taller comunitario"
                className="w-full h-52 object-cover"
                loading="lazy"
              />
              <div className="p-8 md:p-10 flex flex-col gap-5">
                <p className="inline-flex items-center gap-2 self-start text-xs font-black uppercase tracking-[0.2em] bg-[var(--blue)] text-white sketch-sm px-3 py-1.5">
                  <MapPin className="w-4 h-4" aria-hidden="true" />
                  Langreo, Asturias
                </p>
                <h3 className="font-display font-extrabold text-2xl md:text-3xl leading-snug">El grupo validador del CAI de Pando</h3>
                <p className="text-base md:text-lg leading-relaxed text-[var(--muted)]">
                  Personas usuarias del Centro de Apoyo a la Integración de Pando integran el proyecto. Se han formado en lectura fácil y son quienes deciden, palabra por palabra, si un texto se entiende de verdad.
                </p>
                <ul className="space-y-3 mt-auto">
                  {VALIDATORS.map((v) => (
                    <li key={v.role} className="flex flex-wrap items-center gap-2 text-base font-bold">
                      {v.names.map((n) => (
                        <span key={n} className="sketch-sm bg-[var(--yellow)] px-3 py-1">
                          {n}
                        </span>
                      ))}
                      <span className="text-[var(--muted)] font-normal">{v.role}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
